<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" md="12" class="pt-1">
          
          <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            multi-line
            app
          >
            {{snackbarText}}
            <v-btn
              text
              dark
              @click="snackbar = false"
            >
              Fermer
            </v-btn>
          </v-snackbar>
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                <span class="headline">Ajouter Agent</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                      
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="Code Agent*" disabled v-model="agentTmp.code" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field label="Nom&Prénom Agent" v-model="agentTmp.nom" required></v-text-field>
                        </v-col>
                        
                        <v-col cols="12" sm="12">
                            <v-text-field label="Poste"  v-model="agentTmp.titre_pro" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Telephone"  v-model="agentTmp.tel" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Email"  v-model="agentTmp.mail" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-text-field label="Adresse"  v-model="agentTmp.adresse" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-file-input
                              v-model="user_picture"
                              @change="selectFile"
                              accept="image/*"
                              label="Photo"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                </v-container>
                <small>*toutes les cases indiquées avec étoiles sont obligatoires</small>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Fermer</v-btn>
                <v-btn color="blue darken-1" text @click="addAgent">Ajouter</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
          <v-expansion-panels v-model="panel" :readonly="readonly" accordion multiple>
              <v-expansion-panel>
                  <v-expansion-panel-header><span class="expan-title"> Liste des Agents</span> </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <div class="ml-2 text-left"><v-btn @click="openDialog" depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;">Nouveau</v-btn></div>
                      <v-data-table
                            :headers="headers"
                            :items="agents"
                            :items-per-page="5"
                            class="elevation-0"
                        >
                          <template v-slot:[`item.picture_url`]="{ item }">
                            <v-avatar>
                              <v-img :src="$baseURL + 'uploads/'+ item.picture_url" width="64px" ></v-img>
                            </v-avatar>
                          </template>
                          <template v-slot:[`item.actions`]="item">
                              <v-btn :ripple="false" @click="openItem(item)" icon>
                                  <v-icon
                                      small
                                      class="mr-2"
                                  >
                                      mdi-eye
                                  </v-icon>
                              </v-btn>
                              <v-icon
                                  small
                                  class="mr-2"
                                  @click="editItem(item.item)"
                              >
                                  mdi-pencil
                              </v-icon>
                              <v-icon
                                  small
                                  :disabled="!permissions.includes('delete_database')"
                                  @click="deleteItem(item.item)"
                              >
                                  mdi-delete
                              </v-icon>
                          </template>
                        </v-data-table>

                  </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
        <v-col md="12" style="height:fit-content;">
            <v-card
            width="98%"
            v-if="currentAgent !== null"
            style="margin: 0 auto; background: none;"
            class="elevation-0"
            >
                <v-row>
                
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Code Agent</v-list-item-title>
                        <v-list-item-subtitle>{{currentAgent.code}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-else md="4">
                  <v-text-field label="Code Agent" outlined hide-details disabled v-model="currentAgent.code" required></v-text-field>  
                </v-col>

                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Nom Agent</v-list-item-title>
                        <v-list-item-subtitle>{{currentAgent.nom}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-else md="4">
                  <v-text-field label="Nom Agent" outlined hide-details v-model="currentAgent.nom" required></v-text-field>  
                </v-col>

                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                      <v-list-item-avatar>
                        <v-img :src="$baseURL + 'uploads/'+ currentAgent.picture_url"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                          <v-list-item-title class="headline mb-1">Photo du Profil</v-list-item-title>
                          <v-list-item-subtitle>{{currentAgent.picture_url}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-else md="4">
                  <v-file-input
                    v-model="user_picture"
                    @change="selectFile"
                    accept="image/*"
                    outlined
                    label="Photo du profil"
                  ></v-file-input>
                </v-col>

                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Adresse</v-list-item-title>
                        <v-list-item-subtitle>{{currentAgent.adresse}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-else md="4">
                  <v-text-field label="Adresse" outlined hide-details v-model="currentAgent.adresse" required></v-text-field>  
                </v-col>
                
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Téléphone</v-list-item-title>
                        <v-list-item-subtitle>{{currentAgent.tel}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-else md="4">
                  <v-text-field label="Téléphone" outlined hide-details v-model="currentAgent.tel" required></v-text-field>  
                </v-col>

                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Poste</v-list-item-title>
                        <v-list-item-subtitle>{{currentAgent.titre_pro}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col v-else md="4">
                  <v-text-field label="Poste" outlined hide-details v-model="currentAgent.titre_pro" required></v-text-field>  
                </v-col>
                
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Email</v-list-item-title>
                        <v-list-item-subtitle>{{currentAgent.mail}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>

                <v-col v-else md="4">
                  <v-text-field label="Email" outlined hide-details v-model="currentAgent.mail" required></v-text-field>  
                </v-col>

                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>  
                  <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" v-if="!edit" @click="edit = true">Editer</v-btn>
                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" v-if="edit" @click="editAgent">Editer</v-btn>
                  <v-btn color="error" @click="deleteItem(currentAgent)" :disabled="!permissions.includes('delete_database')">Supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>
<script>

export default {
  name: 'manage-agents',
  props: ['permissions'],
  data: () => ({
    drawer: true,
    panel: [0],
    currentManagement: {title: 'Tous'},
    business: 5,
    filterSelectbox: ['Tous','Import', 'Export'],
    mini: false,
    readonly: true,
    currentAgent: null,
    search: '',
    expanded: [],
    edit: false,
    user_picture: null,
    drawerClass: '',
    dialog: false,
    headers: [
        { text: '#', sortable: false, value: 'picture_url' },
        {
        text: 'Code',
        align: 'start',
        value: 'code',
        },
        { text: 'Nom', value: 'nom' },
        { text: 'Adresse', value: 'adresse' },
        { text: 'Telephone', value: 'tel' },
        { text: 'Email', value: 'mail' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    agents: [],
    agentTmp: {},
    snackbar: false,
    snackbarText: '',
    color: "success"
    
 
  }),
  ///agent/listing
  mounted () {
      this.axios
          .get('/agent/listing')
          .then(response => (this.agents = response.data))
    },
  methods: {
      selectFile(file) {
        this.user_picture = file
      },
      reloadData(){
        this.axios
          .get('/agent/listing')
          .then(response => (this.agents = response.data))
      },
      openItem(item){
          this.panel = [1];
          this.readonly = false;
          this.currentAgent = item.item;
      },
      editItem(item){
        this.edit = true
        this.panel = [1];
        this.readonly = false;
        this.currentAgent = Object.assign({}, item);
      },
      editAgent(){
        let formData = new FormData()
        formData.append('picture_url', this.user_picture)
        formData.append('nom', this.currentAgent.nom)
        formData.append('id', this.currentAgent.id)
        formData.append('titre_pro', this.currentAgent.titre_pro)
        formData.append('code', this.currentAgent.code)
        formData.append('adresse', this.currentAgent.adresse)
        formData.append('tel', this.currentAgent.tel)
        formData.append('mail', this.currentAgent.mail)
        this.axios.put('/agent/edit', formData, {
           headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((res) => {
            if(res.data === 'error'){
            this.color = "error"
            this.snackbarText = "Essayez de remplir tous les champs obligatoires."
            this.snackbar = true
            }else{
            this.color = "success"
            this.snackbarText = "L'agent a été modifié avec succès."
            this.snackbar = true
            if(this.user_picture){
              this.currentAgent.picture_url = this.user_picture.name
              //console.log(this.user_picture)
            }
            this.user_picture = null
            this.reloadData()
            this.edit = false
            }
        }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
        })
      },
      openDialog(){
        if(this.agents.length > 0){
          var nextCode = this.agents.reduce((max, p) => p.code > max ? p.code : max, this.agents[0].code)
          if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
            nextCode = Number(nextCode)+1
          }else{
            nextCode = new Date().getFullYear()+'0001';
          }
        }else{
          nextCode = new Date().getFullYear()+'0001';
        }
        
        this.agentTmp.code = nextCode
        this.dialog = true
      },
      addAgent(){
        let formData = new FormData()
        formData.append('picture_url', this.user_picture)
        formData.append('nom', this.agentTmp.nom)
        formData.append('titre_pro', this.agentTmp.titre_pro)
        formData.append('code', this.agentTmp.code)
        formData.append('adresse', this.agentTmp.adresse)
        formData.append('tel', this.agentTmp.tel)
        formData.append('mail', this.agentTmp.mail)
        //this.agentTmp.picture_url = this.user_picture
        this.axios.post('/agent/create', formData, {
           headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then((res) => {
            if(res.data === 'error'){
              this.color = "error"
              this.snackbarText = "Essayez de remplir tous les champs obligatoires."
              this.snackbar = true
            }else{
              this.color = "success"
              this.snackbarText = "L'agent a été ajouté avec succès."
              this.snackbar = true
              this.reloadData()
              this.dialog = false
              this.agentTmp = {}
              this.user_picture = null
            }
            
          }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
          })
      },

      deleteItem (item) {
        const index = this.agents.indexOf(item)
        this.axios.delete('/agent/delete/' + item.id)
        .then(response => {
          if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.agents.splice(index, 1)){
            this.color = "success"
            this.snackbarText = "L'agent a été supprimé avec succès."
            this.snackbar = true
            this.currentAgent = null
            this.panel = [0]
          }
          
        });
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .v-expansion-panel:before {
    box-shadow: 0 0 0 transparent !important;
  }
  .expan-title{
    color: #000;
    font-weight: 700;
    font-size: 18px;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table td, .v-data-table th{
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/database/agent/listing.vue